import { Injectable } from '@angular/core';
import { PATH } from '../constants/paths.constants';
import { Haptics } from '@capacitor/haptics';
import { Howl } from 'howler';

@Injectable({
  providedIn: 'root',
})
export class NotificationSoundService {
  sound: Howl;

  constructor() {
    this.sound = new Howl({
      src: [PATH.SIMPAYX_NEW_ORDER_SOUND],
      volume: 1.0,
      loop: true,
      onplay: () => this.triggerVibration(),
    });
  }

  async triggerVibration() {
    try {
      await Haptics.vibrate();
    } catch (error) {
      console.error('Vibration not supported:', error);
    }
  }

  playNotificationSound(): void {
    if (!this.sound.playing()) {
      this.sound.play();
    }
    console.log('notification sound');
  }

  stopNotificationSound(): void {
    if (this.sound.playing()) {
      this.sound.stop();
    }
    console.log('notification sound stopped');
  }
}
